import { Component, OnInit } from '@angular/core';
import {
  StepType,
  RegistrationStepQuery,
  RegistrationStepService,
  ErrorStateService,
  MemberDetails,
  ProviderTranslation,
  RegistrationStepStore,
  ProviderTranslationStatus,
} from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'fgbcl-registration-provider-translation',
  templateUrl: './registration-provider-translation.component.html',
  styleUrls: ['./registration-provider-translation.component.scss'],
})
export class RegistrationProviderTranslationComponent implements OnInit {
  readonly stepType = StepType.ProviderTranslation;

  externalRef: string = '';
  accountsList: ProviderTranslation[] = [];
  loading = true;
  title = '';
  description = '';

  constructor(
    private registrationStepQuery: RegistrationStepQuery,
    private registrationStepService: RegistrationStepService,
    private registrationStepStore: RegistrationStepStore,
    public errorService: ErrorStateService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.registrationStepService.getStepDataAndHandle(this.stepType);

    const externalRef = this.registrationStepQuery.getQueryData('externalRef');
    if (externalRef) {
      // Skip this step if we already selected an account when entering into the registration process
      let accountList = this.registrationStepQuery.getStep(this.stepType)?.Data as ProviderTranslation[];
      if (!accountList) {
        accountList = [{ ExternalRefNumber: externalRef, SelectedAccount: true }] as ProviderTranslation[];
      } else {
        let accountListCloned = JSON.parse(JSON.stringify(accountList)) as ProviderTranslation[];
        let currentAccount = accountListCloned.find((x) => x.ExternalRefNumber === externalRef) as ProviderTranslation;
        currentAccount.SelectedAccount = true;
        if (currentAccount !== null) {
          this.registrationStepStore.update(this.stepType, (step) => ({ ...step, Data: accountListCloned }));
        }
      }
      this.registrationStepService.submitRegistrationStepData(this.stepType, accountList).toPromise();
      return;
    }

    firstValueFrom(
      this.registrationStepService.fetchRegistrationStepForCurrentWizard(StepType.ProviderTranslation, true, true)
    ).then((step) => {
      if (step.ShouldSkip) return;

      if (step && step.Data) {
        // x.Data is a <ProviderTranslationModel[]>
        this.accountsList = step.Data;
        if (this.accountsList.length === 1) {
          this._autoNextStep(this.accountsList[0]);
        } else {
          this.title = 'fgbcl.registration.provider.translation.choose.account.text';
          this.description = 'fgbcl.registration.provider.translation.choose.account.description.text';
          this.loading = false;
        }
      } else {
        this.errorService.addError(
          this.translate.instant('fgbcl.registration.provider.translation.failed.availble.account.text')
        );
        this.loading = false;
      }
    });
  }

  private _autoNextStep(account: ProviderTranslation) {
    if (account.Status === ProviderTranslationStatus.Active) {
      document.location.href = account.RedirectUrl;
    } else {
      this.submitStep(account.ExternalRefNumber);
    }
  }

  public submitStep(externalRef: string) {
    if (!externalRef) {
      this.title = 'fgbcl.registration.provider.translation.account.selection.text';
      this.description = 'fgbcl.registration.provider.translation.account.selection.description.text';
      this.errorService.addError(this.translate.instant('fgbcl.registration.provider.translation.no.account.selected.text'));
      return;
    }

    let accountList = this.registrationStepQuery.getStep(this.stepType)?.Data as ProviderTranslation[];
    if (!accountList) {
      accountList = [{ ExternalRefNumber: externalRef, SelectedAccount: true }] as ProviderTranslation[];
    }

    let accountListCloned = JSON.parse(JSON.stringify(accountList)) as ProviderTranslation[];
    let currentAccount = accountListCloned.find((x) => x.ExternalRefNumber === externalRef) as ProviderTranslation;
    currentAccount.SelectedAccount = true;
    if (currentAccount !== null) {
      this.registrationStepStore.update(this.stepType, (step) => ({ ...step, Data: accountListCloned }));
    }

    this.registrationStepService
      .submitRegistrationStepData(this.stepType, accountListCloned)
      .toPromise()
      .then(() => (this.loading = false));
  }

  public selectAccount(account: MemberDetails) {
    if (account.ExternalRefNumber) {
      this.externalRef = account.ExternalRefNumber;
    }
  }

  goToPreviousStep(): void {
    this.registrationStepService.navigateToPreviousStep(this.stepType);
  }
}
